import React from "react";
import { Card, } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";

const CategoryQT = ({ template }) => {

    
  if (!template) {
    return (
      <Card className="h-100">
        <Card.Header>Template Questions</Card.Header>
        <Card.Body className="text-muted">
          Select a template to view its questions
        </Card.Body>
      </Card>
    );
  }
  console.log("Temple", template);
  return (
    <Card className="mb-4">
  <Card.Header>
    Template: <Link to= {`/questionform/${template.id}`}><strong>{template.template_name}</strong></Link>
  </Card.Header>

  <Card.Body style={{ maxHeight: "600px", overflowY: "auto" }}>
    {template.questions?.length ? (
      template.questions.map((q, index) => (
        <div
          key={q.id}
          className="d-flex justify-content-between align-items-center border rounded p-2 mb-2 bg-light"
        >
          <div className="d-flex align-items-center gap-2">
            <strong>
              {index + 1}. {q.questionText}
            </strong>
            <div className="d-flex gap-2 mt-1">
              <span className="badge" style={{ backgroundColor: "rgba(0,123,255,0.15)", color: "#0d6efd", borderRadius: "12px", fontWeight: "600", padding: "5px 10px", fontSize: "13px" }}>
                {q.answerType}
              </span>

              {q.isRequired && (
                <span className="badge" style={{ backgroundColor: "rgba(220,53,69,0.15)", color: "#ff9800", borderRadius: "12px", fontWeight: "600", padding: "5px 10px", fontSize: "13px" }}>
                  Required
                </span>
              )}

              <span className="badge" style={{ backgroundColor: q.isActive ? "rgba(40,167,69,0.15)" : "rgba(220,53,69,0.15)", color: q.isActive ? "#28a745" : "#dc3545", borderRadius: "12px", fontWeight: "600", padding: "5px 10px", fontSize: "13px" }}>
                {q.isActive ? "Active" : "Inactive"}
              </span>
            </div>
          </div>
        </div>
      ))
    ) : (
      <div className="text-muted">No questions in this template</div>
    )}
  </Card.Body>
</Card>

  );
};

export default CategoryQT;
